export default __webpack_public_path__ + "static/villa5-c86a676bd441fcfa8f4daad9d8ba5430.jpeg";